<!-- ======= Hero Section ======= -->
<div class="mobile_version-backbutton">
    <a class="mobile-header" onclick="history.back()">
        <span> <img src="../../../assets/images/tournament/backBtn.svg" alt=""> </span></a>
</div>
<div class="topTitle mainTopTitle">
    <h2>Refer & Earn</h2>
</div>



<!-- <div class="col-md-12 d-flex justify-content-center mb-3 headers-headings mobile-header-div"><a onclick="history.back()"
        class="mobile-header"><i class="bx bx-chevron-left"></i> Refer & Earn </a></div> -->


<section class="Wallet-secrion mb-0 pb-0 frist-div"
    [ngClass]="isProfileComplete && !isAcademy ? 'none-academy ' : 'pt-0 user'" *ngIf="!isAcademy">
    <div class="container">
        <div class="row m-0">
            <div class="col-md-12 wallet-div">
                <div class="iconDiv">
                    <img src="../../../assets/images/refer/Megaphone.png" alt="">
                </div>
                <div class="leftDiv">
                    <div class="topTitle">
                        <h2>
                            REFER & EARN ₹100!
                        </h2>
                        <h6>
                            Invite your friends to join the TPL App.
                        </h6>
                        <p class="para-text">
                            Earn ₹100 for every user who signs up using your referral code and completes their first
                            tournament!
                        </p>
                        <div class="refreal-div">
                            <div class="buttonList">
                                <a href="{{shareurl}}" target="_blank">
                                    <button class="shareBTn">
                                        <div class="icon">
                                            <img src="../../../assets/images/refer/share.svg" alt="">
                                        </div>
                                        <div class="titleText">
                                            <h5>{{this.referralcode}}</h5>
                                            <p>REFERAL CODE</p>
                                        </div>
                                    </button>
                                </a>

                                <a href="{{shareurl}}" target="_blank">
                                    <button class="whatsappBtn">
                                        <div class="icon">
                                            <img src="../../../assets/images/refer/whatsapp.svg" alt="">
                                        </div>
                                        <h5>SHARE</h5>
                                    </button>
                                </a>

                            </div>
                            <!-- <div class="form">
                            <input type="text" value="https://www.tplsport.com/login-register?ref={{this.referralcode}}"
                                disabled>
                        </div> -->
                            <!-- <div class="share-button">
                            <a href="{{shareurl}}" target="_blank"> <button>Invite <span><i
                                            class='bx bx-share-alt'></i></span> </button></a>
                        </div> -->
                        </div>
                    </div>



                </div>

                <div class="col-md-12 rafferal-main-div">
                    <!-- <div class="refreal-div">
                        <div class="form">
                          <input type="text" #inputRef value="https://www.tplsport.com/{{this.referralcode}}">
                          
                        </div>
                        <div class="share-button">
                          <a href="{{shareurl}}" target="_blank">
                            <a href="{{shareurl}}" target="_blank">  <button>Invite <span><i class='bx bx-share-alt'></i></span> </button></a>
                          </a>
                        </div>
                       
                      </div>
                      <button (click)="copyInputValue()">Copy Input Value <span><i class='bx bx-copy'></i></span></button> -->



                </div>
            </div>
            <div class="earnTips">
                <h2>HOW TO EARN ₹100 PER FRIEND</h2>
                <ul>
                    <li>
                        <div class="icondivmain">
                            <div class="icon">
                                <img src="../../../assets/images/refer/icon1.png" alt="">
                            </div>
                            <div class="stepsdetails">
                                <h6 class="stepsTitle">Step 1</h6>
                                <h4 class="stepsHeading">Invite Your Friends</h4>
                                <p>Share your referral code and invite your friends to register on the TPL App.</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="icondivmain">
                            <div class="icon">
                                <img src="../../../assets/images/refer/icon2.png" alt="">
                            </div>
                            <div class="stepsdetails">
                                <h6 class="stepsTitle">Step 2</h6>
                                <h4 class="stepsHeading">Earn 1000 Coins</h4>
                                <p>Share your referral code and invite your friends to register on the TPL App.</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="icondivmain">
                            <div class="icon">
                                <img src="../../../assets/images/refer/icon3.png" alt="">
                            </div>
                            <div class="stepsdetails">
                                <h6 class="stepsTitle">Step 3</h6>
                                <h4 class="stepsHeading">Get ₹100 on First Tournament</h4>
                                <p>Earn ₹100 when your referred friend registers for their first tournament.</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="icondivmain">
                            <div class="icon">
                                <img src="../../../assets/images/refer/icon4.png" alt="">
                            </div>
                            <div class="stepsdetails">
                                <h6 class="stepsTitle">Step 4</h6>
                                <h4 class="stepsHeading">Enjoy 2% Lifetime Earnings</h4>
                                <p>Earn 2% of your friend's transaction amount for life — every time they do a
                                    transaction on the app!</p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>
<section class="Wallet-secrion mb-0 pb-0 frist-div" *ngIf="isAcademy">
    <div class="container">
        <div class="row m-0">
            <div class="col-md-12 wallet-div">
                <div class="wallet-heading">
                    <h1>
                        Refer a Friend/Player
                    </h1>
                    <p class="para-text">Don't miss out on the opportunity to earn rewards while sharing the benefits of
                        our platform with your network. Start referring today and be a part of our growing community.
                    </p>
                </div>
                <div class="col-md-12 rafferal-main-div">
                    <!-- <div class="refreal-div">
                        <div class="form">
                          <input type="text" #inputRef value="https://www.tplsport.com/{{this.referralcode}}">
                          
                        </div>
                        <div class="share-button">
                          <a href="{{shareurl}}" target="_blank">
                            <a href="{{shareurl}}" target="_blank">  <button>Invite <span><i class='bx bx-share-alt'></i></span> </button></a>
                          </a>
                        </div>
                       
                      </div>
                      <button (click)="copyInputValue()">Copy Input Value <span><i class='bx bx-copy'></i></span></button> -->

                    <div class="refreal-div">
                        <div class="form">
                            <input type="text" value="https://www.tplsport.com/sign-up?ref={{this.referralcode}}"
                                disabled>
                        </div>
                        <div class="share-button">
                            <a href="{{shareurl}}" target="_blank"> <button>Invite <span><i
                                            class='bx bx-share-alt'></i></span> </button></a>
                        </div>
                    </div>

                </div>
            </div>


        </div>
    </div>
</section>
<section class="Wallet-secrion second-div " [ngClass]="isAcademy ? 'acadmy-sectionDiv ' : 'pt-0 none-academy'"
    *ngIf="(isAcademy) || (!isAcademy)">
    <div class="container">
        <div class="row m-0">
            <div class="col-md-12 wallet-div">
                <h2>total referee</h2>


                <div class="balance-list" [ngClass]="isAcademy ? 'academy-mainlist ' : 'user-mainlist'">
                    <div class="tpls-cash-and-coins total-reward-div">
                        <div class="top-div">
                            <div class="icon">
                                <img src="../../../assets/images/refer/refree.svg" alt="">
                            </div>
                            <div class="title">
                                <h4>Total Coins Earn</h4>
                                <h6>{{this.totalAvailableCoins}}</h6>
                            </div>
                        </div>
                        <div class=" redemption hidden-div-acadmy">
                            <button class="redeem" (click)="transferAmountToBank(this.userId)">
                                Claim <i class='bx bx-up-arrow-alt'></i>
                            </button>
                        </div>
                    </div>
                    <div class="tpls-cash-and-coins total-reward-div">
                        <div class="top-div">
                            <div class="icon">
                                <i class='bx bx-gift'></i>
                            </div>
                            <div class="title">
                                <h4>Total Reward Earn</h4>
                                <h6><i class='bx bx-rupee'></i>{{totalAvailableCash}}</h6>
                            </div>
                        </div>
                        <div class=" redemption">
                            <!-- academy redemption Not required for now -->
                            <button class="redeem" (click)="transferAmountToBank(this.userId)"
                                style="visibility: hidden;pointer-events: none">
                                Claim <i class='bx bx-up-arrow-alt'></i>
                            </button>
                        </div>

                    </div>
                    <div class="refreeDiv">
                        <div class="mainIconDivRefree">
                            <div class="icon">
                                <img src="../../../assets/images/refer/refree.svg" alt="">
                            </div>
                            <div class="title">
                                <h4>{{totalReferee}} Total Referee</h4>
                                <!-- <p class="textdiv">You have earned <span>₹0</span> till now!</p> -->
                            </div>
                            <button class="redeemBTnmain" (click)="viewReferreList()">
                                VIEW REFEREE
                            </button>
                        </div>

                        <!-- <div class=" redemption">
                            <button class="redeem btn-primery" >
                                View <i class='bx bx-show-alt'></i>
                            </button>
                        </div> -->

                    </div>

                </div>


                <!-- <div class="balance-list">
                    <div class="tpls-cash-and-coins">
                        <div class="title">
                            <h4>Cash</h4>
                            <h6>{{totalAvailableCash}}</h6>
                        </div>
                        <div class="add-button">
                            <button (click)="addCash()">Add More Cash <span><i class='bx bx-plus'></i></span></button>
                        </div>
                    </div>
                    <div class="pipe"></div>
                    <div class="tpls-cash-and-coins">
                        <div class="title">
                            <h4>Coins</h4>
                            <h6>{{totalAvailableCoins}}</h6>
                        </div>
                        <div class="add-button"> -->
                <!-- <button (click)="addCoin()">Use Coins <span><i class='bx bx-plus'></i></span></button> -->
                <!-- </div>
                    </div>
                </div> -->
                <div class=" col-md-12 transation-history" *ngIf="isAcademy">
                    <div class="tableheader-heading">
                        <h2>
                            Referral Guidelines
                        </h2>
                    </div>
                    <div class="table-div w-100">
                        <div class="rules">
                            <ul>
                                <li> When player used Academy referal code to signup he will get 1000 bonus coins to his
                                    wallet.</li>
                                <li> The Academy will get 2% every time when the referee does any transaction such as
                                    register tournament. </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class=" col-md-12 transation-history" *ngIf="isAcademy">
                    <div class="tableheader-heading">
                        <h2>
                            Referral History
                        </h2>
                    </div>
                    <div class="table-div w-100">
                        <p-table #dt [value]="walletlist" [paginator]="true" [rows]="10" [lazy]="true" appendTo=""
                            [autoLayout]="true" (onLazyLoad)="loadWalletHistory($event)"
                            [totalRecords]="totalUserWalletRecords" [loading]="loading" pageLinks="3"
                            [showPageLinks]="true" [rowsPerPageOptions]="paginationOption" paginatorPosition="bottom">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="display: table-cell!important;" pSortableColumn="id"
                                        class="transactionId">Transaction ID</th>
                                    <th style="display: table-cell!important;" pSortableColumn="description"
                                        class="transactiodescription">Description</th>
                                    <th style="display: table-cell!important;" pSortableColumn="created_at"
                                        class="date">Date</th>
                                    <th style="display: table-cell!important;" pSortableColumn="email"
                                        class="amount-div">Amount</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-wallet let-i="rowIndex">
                                <tr class="p-selectable-row">
                                    <td class="transactionId">
                                        <!-- {{wallet.id}} -->
                                        {{ i + 1 }}

                                    </td>
                                    <td class="transactiodescription">
                                        {{wallet.description}}
                                        <div class="mobile-date-div">
                                            {{wallet.created_at | date: 'dd MMM, yyyy'}}
                                        </div>
                                    </td>
                                    <td class="date">
                                        {{wallet.created_at | date: 'dd MMM, yyyy'}}
                                    </td>
                                    <td *ngIf="wallet.action=='ADD'" class="amount-div">
                                        <i class='bx bx-plus'></i> {{wallet.amount}} {{wallet.wallettype | lowercase }}
                                    </td>
                                    <td *ngIf="wallet.action=='SUBTRACT'" class="amount-div">
                                        <i class='bx bx-minus'></i> {{wallet.amount}} {{wallet.wallettype | lowercase }}
                                    </td>
                                    <!-- <td *ngIf="wallet.coins!=0">                                    
                                    <div class="debit" *ngIf="wallet.action=='ADD'">
                                        <i class='bx bx-plus'></i> {{wallet.coins}} {{wallet.wallettype | lowercase }}<span></span>
                                    </div>
                                    <div class="credits" *ngIf="wallet.action=='SUBTRACT'">
                                        <i class='bx bx-minus'></i> {{wallet.coins}} {{wallet.wallettype | lowercase}} <span></span>
                                    </div>
                                    
                                </td>
                                <td *ngIf="wallet.cash!=0">
                                    <div class="debit" *ngIf="wallet.action=='ADD'">
                                        <i class='bx bx-plus'></i> {{wallet.cash}} {{wallet.wallettype | lowercase}}<span></span>
                                    </div>
                                    <div class="credits" *ngIf="wallet.action=='SUBTRACT'">
                                        <i class='bx bx-minus'></i> {{wallet.cash}} {{wallet.wallettype | lowercase}} <span></span>
                                    </div>
                                </td> -->
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="5">No Data found.</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="summary">
                                <div class="p-d-flex p-ai-center p-jc-between">
                                    In total there are {{totalUserWalletRecords }} Records.
                                </div>
                            </ng-template>
                        </p-table>
                    </div>
                </div>

            </div>
        </div>
    </div>

</section>

<!-- <section  class="profile-in-compelet-ui"  *ngIf="!isAcademy && !isProfileComplete">
    <div *ngIf="!isAcademy && !isProfileComplete" class="container">
        <div class="profile-complete-main-div">
            <div class="incompeleted-profile">
            
             <div class="icon-refer">
                <img src="../../../assets/img/undraw_alert_re_j2op.svg" alt="">
             </div>
             <div class="title-heading">
                <h4>Profile Incomplete!  </h4>
            </div>
            </div>
            <span>Please Complete Your Profile for a Better Tennis Experience! </span>
            <p>
                Unlock personalized updates, connect with players, and get exclusive access.<br> Upload a picture, share your favorites, and set your goals now!
            </p>
    
            <div class="complted-profile">
                <button routerLink="/profile-edit">Complete Profile <i class='bx bx-pencil'></i></button>
            </div>
        </div>
    </div>
</section> -->
<div class="actionsBtn mobileActionBtn">
 <div class="buttonList">
                                <a href="{{shareurl}}" target="_blank">
                                    <button class="shareBTn">
                                        <div class="icon">
                                            <img src="../../../assets/images/refer/share.svg" alt="">
                                        </div>
                                        <div class="titleText">
                                            <h5>{{this.referralcode}}</h5>
                                            <p>REFERAL CODE</p>
                                        </div>
                                    </button>
                                </a>

                                <a href="{{shareurl}}" target="_blank">
                                    <button class="whatsappBtn">
                                        <div class="icon">
                                            <img src="../../../assets/images/refer/whatsapp.svg" alt="">
                                        </div>
                                        <h5>SHARE</h5>
                                    </button>
                                </a>

                            </div>
</div>
<p-dialog class="add-amont-popup" [(visible)]="addCashmodal" [modal]="true" [style]="{width: '500px'}" header="Add Cash"
    [breakpoints]="{'960px': '60vw', '640px': '100vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false"
    (onHide)="cashclose()">

    <form [formGroup]="addCashForm" *ngIf="this.addCashForm">
        <div class="p-fluid p-formgrid p-grid">
            <div class="wallet-icons">
                <div class="icon"><i class="bx bx-wallet-alt"></i></div>
                <h1>Enter Amount</h1>
            </div>
            <div class="p-field p-col-12">
                <!-- <label for="amount">Amount<span class="mandatory-fields">*</span></label> -->
                <input formControlName="amount" type="text" pInputText class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.amount.errors }" placeholder="₹ 0">
                <div *ngIf="submitted && f.amount.errors" class="invalid-feedback">
                    <div *ngIf="f.amount.errors.required">Amount is required</div>
                    <div *ngIf="!f.amount.errors.required && f.amount.errors">Only Numbers allowed</div>
                </div>
            </div>
            <div class="p-field p-col-12 msg-div">
                <p-messages severity="info">
                    <ng-template pTemplate>
                        <i class="pi pi-info-circle"></i>
                        <div class="ml-2">Please Note: For iPhone users - To make a payment using Gpay, select "Others"
                            option in the UPI menu and manually enter your UPI ID.</div>
                    </ng-template>
                </p-messages>

            </div>
        </div>
        <div class="col-md-12 text-center">

            <button type="button" (click)="onCashSubmit()" pButton label="Add To Wallet"
                class="p-button-primery save-btn p-mr-0" style="width: auto"></button>
        </div>
    </form>
</p-dialog>
<p-dialog [(visible)]="showThankyouModal" [modal]="true" [style]="{width: '500'}" header="Thank You"
    [breakpoints]="{'960px': '60vw', '640px': '100vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false"
    (onHide)="closeThankyou()">
    <div class="col-md-12">
        Amount added to Wallet Successfully.
    </div>
</p-dialog>

<p-dialog class="add-amont-popup" [(visible)]="addCoinmodal" [modal]="true" [style]="{width: '500px'}"
    header="Add Coins" [breakpoints]="{'960px': '60vw', '640px': '100vw'}" [baseZIndex]="10000" [draggable]="false"
    [resizable]="false" (onHide)="coinclose()">
    <!-- <form [formGroup]="addCoinForm" *ngIf="this.addCoinForm">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12">
                <label for="amount">Amount<span class="mandatory-fields">*</span></label>
                <input formControlName="amount" type="text" pInputText class="form-control"
                    [ngClass]="{ 'is-invalid': coinsubmitted && f1.amount.errors }">
                <div *ngIf="coinsubmitted && f1.amount.errors" class="invalid-feedback">
                    <div *ngIf="f1.amount.errors.required">Amount is required</div>
                    <div *ngIf="!f1.amount.errors.required && f1.amount.errors">Only Numbers allowed</div>
                </div>
            </div>
            <div class="p-field p-col-12">Note: 1 Cash equal to 10 Coins</div>
        </div>
        <button type="button" (click)="onCoinSubmit()" pButton icon="pi pi-check" label="Checkout"
            class="p-button-success save-btn p-mr-0" style="width: auto"></button>
    </form> -->

    <form [formGroup]="addCoinForm" *ngIf="this.addCoinForm">
        <div class="p-fluid p-formgrid p-grid">
            <div class="wallet-icons">
                <div class="icon"><i class="bx bx-wallet-alt"></i></div>
                <h1>Enter Amount</h1>
            </div>
            <div class="p-field p-col-12 mb-0">
                <!-- <label for="amount">Amount<span class="mandatory-fields">*</span></label> -->
                <input formControlName="amount" type="text" pInputText class="form-control"
                    [ngClass]="{ 'is-invalid': coinsubmitted && f1.amount.errors }" placeholder="₹ 0">
                <div *ngIf="coinsubmitted && f1.amount.errors" class="invalid-feedback">
                    <div *ngIf="f1.amount.errors.required">Amount is required</div>
                    <div *ngIf="!f1.amount.errors.required && f1.amount.errors">Only Numbers allowed</div>
                </div>
            </div>
            <div class="p-field p-col-12  text-center" style="color:#000;">Note: 1 Cash equal to 10 Coins</div>
        </div>
        <div class="col-md-12 text-center">

            <button type="button" (click)="onCoinSubmit()" pButton label="Add To Wallet"
                class="p-button-primery save-btn p-mr-0" style="width: auto"></button>
        </div>
    </form>

</p-dialog>